
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PaginationV2',

  props: {
    pageNumber: {
      type: Number,
      required: true
    },
    perPageCount: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    }
  },

  computed: {
    modelValue: {
      get(): number {
        return this.pageNumber
      },
      set(value: number) {
        this.$emit('change', value)
      }
    },

    disableBackAction(): boolean {
      return this.modelValue <= 1
    },

    disableForwardAction(): boolean {
      return this.modelValue >= Math.ceil(this.totalCount / this.perPageCount)
    },

    end(): number {
      const count = this.perPageCount * this.modelValue
      return count > this.totalCount ? this.totalCount : count
    },

    start(): number {
      return this.perPageCount * (this.modelValue - 1) + 1
    }
  },

  methods: {
    backActionClickHandler(): void {
      if (!this.disableBackAction) {
        this.$emit('change', this.modelValue - 1)
      }
    },

    forwardActionClickHandler(): void {
      if (!this.disableForwardAction) {
        this.$emit('change', this.modelValue + 1)
      }
    }
  }
})
